var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"page-spinner"},[_c('div',{staticClass:"base-spinner img-fluid"},[_c('lottie-animation',{attrs:{"path":"./sh-spinner.json","loop":true}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }